module.exports = __webpack_public_path__ + "static/Muxioo-e4a2407ac34fa38d6ebcede9ac4c75e3.png";